export enum ELicenseAction {
  FETCH_LICENSE_INFO = "FETCH_LICENSE_INFO",
  UPDATE_LICENSE_INFO = "UPDATE_LICENSE_INFO",
}

export interface FetchLicenseAction {
  type: ELicenseAction;
  isAllowToRun: boolean;
}

export const licenseAction = {
  fetchLicenseInfo(isAllowToRun: boolean): FetchLicenseAction {
    return {
      type: ELicenseAction.FETCH_LICENSE_INFO,
      isAllowToRun: isAllowToRun,
    };
  },
  updateLicenseInfo(isAllowToRun: boolean): FetchLicenseAction {
    return {
      type: ELicenseAction.UPDATE_LICENSE_INFO,
      isAllowToRun: isAllowToRun,
    };
  },
};
